import { render } from "./registerform.vue?vue&type=template&id=215bdf59"
import script from "./registerform.vue?vue&type=script&lang=js"
export * from "./registerform.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__